import * as api from './index';

export function getCarrierByDotNumber(dotNumber) {
    return api.get(`/fmcsa/carriers/${dotNumber}`);
}
